<!--
  Modified by Justin Jäger for the Unfolded.Tools Remote Simulator.
  Modified build first published: 2026-08-03.
  Licensed as part of the modified Web Configurator under GNU GPL v3.0 only.
  See MODIFICATIONS.md for details.
-->
<script setup lang="ts">
import { computed, onMounted, ref, useTemplateRef, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";
import sStorageWrapper from "@/api/local";
import type { TabItem } from "@/types/ui";
import { focusInput } from "@/composables/device";
import UCSearch from "@/components/ui/UCSearch.vue";
import TabMenu from "@/components/ui/TabMenu.vue";
import IntegrationList from "@/components/integration/IntegrationList.vue";

type IntegrationsFilter = { activeTab?: TabItem; searchText?: string };
const { t } = useTranslation();
const route = useRoute();
const router = useRouter();
const FILTER_STORE_KEY = "integrations";
const defaultTabItem = computed(() => ({ label: t("integration.integrations"), value: "integration" }));
const tabItems = computed(() => [defaultTabItem.value]);
const activeTab = ref<TabItem>({ value: "integration" });
const searchText = ref("");
const storedFilters = ref<Record<string, any>>({});
const elPageDevicesTools = useTemplateRef<HTMLDivElement>("elPageDevicesTools");
const init = ref(true);
watch(activeTab, () => { if (!init.value) { if (elPageDevicesTools.value) focusInput(elPageDevicesTools.value); saveToStorage(); } });
watch(searchText, saveToStorage);
function goTo() { activeTab.value = defaultTabItem.value; void router.replace({ path: route.path, query: { ...route.query, category: "integration" } }); }
function saveToStorage() { storedFilters.value[FILTER_STORE_KEY] = { activeTab: defaultTabItem.value, searchText: searchText.value } satisfies IntegrationsFilter; sStorageWrapper.setValue("filters", storedFilters.value); }
onMounted(() => { storedFilters.value = (sStorageWrapper.getValue("filters") as Record<string, any>) ?? {}; const stored = storedFilters.value[FILTER_STORE_KEY] as IntegrationsFilter | undefined; searchText.value = stored?.searchText || ""; goTo(); init.value = false; });
</script>
<template>
  <div class="page-devices">
    <div ref="elPageDevicesTools" class="page-devices__tools">
      <TabMenu :list-data="tabItems" :active-tab="activeTab" :compact="true" @item-click="goTo" />
      <div class="page-devices__tools__filter"><div class="page-devices__tools__filter__search"><UCSearch v-model="searchText" :debouncing="true" :small="true" /></div></div>
    </div>
    <div class="page-devices__body"><div class="page-devices__body__inner"><IntegrationList :search-text="searchText" /></div></div>
  </div>
</template>
